<template>
  <div :class="`page-${$route.name}`"
       class="page-content">
    <!--TODO: BREADCRUMBS-->
    <left-navigation/>
    <div class="content">
      <!--TODO: BREADCRUMBS-->
      <breadcrumbs/>
      <!-- :TODO CONTENT -->
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
    'left-navigation': () => import(/* webpackChunkName: 'Breadcrumbs' */ '@/components/LeftNavigation/Index'),
    'breadcrumbs': () => import(/* webpackChunkName: 'Breadcrumbs' */ '@/components/Breadcrumbs')
  }
}
</script>
<style lang="stylus">
  .page-UsersManagement {

  }
</style>
